import { Row } from 'antd';
import styled from 'styled-components';
import { CiOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const AppointmentAvailability = styled.div`
  background: ${({ available }) => (available ? '#E7F5DA' : '#FFEDF3')};
  color: ${({ available }) => (available ? '#3DBC6A' : '#FF2E77')};
  border-radius: 20px;
  display: flex;
  gap: 20px;
  margin: auto;
  margin-top: 4px;

`;

const AvailabilityText = styled.span`
  display: flex;
  margin: auto;
  min-width: 150px;
  justify-content: center;
  align-content: center;
`;

const TextP = styled.p`
  text-align: unset;
`;

const HighlightedText = styled.span`
  font-weight: bold;
`;

const ContentDatesAvailability = styled(Row)`
  margin-bottom: 20px;
  margin-top: 10px;
`;

const ContentAppointment = styled.div`
  display: flex;
  justify-content: flex-start;
  .icon{
    margin-top: 2px;
    margin-right: 3px;
  }
`;

const StyledSpan = styled.span`
  display: flex;
  justify-content: center;
  margin-left: 5px;
  margin-top: 4px;
`;

const StyledIconCiOutlined = styled(CiOutlined)`
  background: #1990ff;
  color: #1990ff;
  font-size: 10px;
  border-radius: 5px;
 
`;

const RowContentAppointment = styled(Row)`
  margin-bottom: 15px;
  margin-top: 15px;
`;

const IconExclamationCircleOutlined = styled(ExclamationCircleOutlined)`
  color: #f98c07;
  margin-right: 10px;
  font-size: 20px;
`;

export {
  AppointmentAvailability,
  AvailabilityText,
  TextP,
  HighlightedText,
  ContentDatesAvailability,
  ContentAppointment,
  StyledSpan,
  StyledIconCiOutlined,
  RowContentAppointment,
  IconExclamationCircleOutlined,
 };

